import type { ResetPasswordRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useResetPassword() {
  return useApiMutation(
    "post",
    "/auth/reset-password",
    {
      notify: false,
      mapVariables: (data: ResetPasswordRequestDto) => ({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      }),
    },
  );
}
